
import {
  defineComponent, shallowRef, onMounted, ref, watch, onUnmounted,
} from 'vue';
import * as echarts from 'echarts';

import store from '@/store';

import {
  getMonitByTime,
} from '../caronMonit';

export default defineComponent({
  setup () {
    // 是否有数据
    const isEmpty = ref(false);
    // 折线图图
    const lineChart = shallowRef<any>({});

    // 配置项
    const lineOptions = {
      color: ['#FF7E00',],
      legend: {
        show: true,
        textStyle: {
          fontSize: 12,
          color: '#222222',
          rich: {
            // 数字下标
            sub: {
              verticalAlign: 'bottom',
              fontSize: 8,
            },
          },
        },
        formatter (name:any) {
          return name
            .replace('CO2', 'CO{sub|2}')
            .replace('CH4', 'CH{sub|4}');
        },
      },
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(0,0,0,0.6)',
        borderWidth: 0,
        textStyle: {
          color: '#fff',
        },
        axisPointer: {
          type: 'line',
          lineStyle: {
            color: '#222222',
          },
        },
      },
      grid: {
        show: false,
        top: '15%',
        bottom: '10%',
        left: 40,
      },
      xAxis: {
        type: 'category',
        axisLabel: {
          textStyle: {
            color: '#222222',
            fontSize: 10,
          },
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: '#E5E6EB',
          },
        },
        axisTick: {
          show: true,
          inside: true,
        },
        data: [],
      },
      yAxis: [
        {
          type: 'value',
          name: 'ppm',
          minInterval: 1,
          max: 435,
          min: 380,
          splitNumber: 5,
          interval: 11,
          nameTextStyle: {
            color: '#3880F2',
            fontSize: 14,
          },
          axisLabel: {
            textStyle: {
              color: '#222222',
              fontSize: 10,
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#E5E6EB',
            },
          },
          axisTick: {
            show: true,
            inside: true,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#E5E6EB',
            },
          },
        },
        {
          type: 'value',
          name: 'ppm',
          max: 2.1,
          min: 1.7,
          splitNumber: 5,
          interval: 0.08,
          nameTextStyle: {
            color: '#3880F2',
            fontSize: 14,
          },
          axisLabel: {
            textStyle: {
              color: '#222222',
              fontSize: 10,
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#E5E6EB',
            },
          },
          axisTick: {
            show: true,
            inside: true,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#E5E6EB',
            },
          },
        },
      ],
      series: [
        {
          name: 'XCO2',
          type: 'line',
          yAxisIndex: 0,
          data: [],
          itemStyle: {
            width: 2,
            type: 'solid',
            color: '#F7BE5B',
          },
        },
        {
          name: 'XCH4',
          type: 'line',
          yAxisIndex: 1,
          data: [],
          itemStyle: {
            width: 2,
            type: 'solid',
            color: '#45D682',
          },
        },
      ],
    };

    const initChart = () => {
      const lineChartContainer = document.getElementById('caron-time-chart') as HTMLElement;

      lineChart.value = echarts.init(lineChartContainer);
    };
    const drawChart = (data:any): void => {
      // 数据渲染
      const { time, co2, ch4, } = data;

      lineOptions.xAxis.data = time;
      lineOptions.series[0].data = co2;
      lineOptions.series[1].data = ch4;
      lineChart.value.setOption(lineOptions);
    };

    onMounted(() => {
      initChart();
      getMonitByTime().then((res:any) => {
        if (res.time.length) {
          drawChart(res);
        } else {
          isEmpty.value = true;
        }
      });
    });
    onUnmounted(() => {
      echarts.dispose(lineChart.value);
      lineChart.value = null;
    });

    return {
      isEmpty,
    };
  },
});
